import * as styles from './index.module.scss';

import { useContext, useEffect, useState } from 'react';
import Image from 'next/image';

import { cleanHeadline, formatDate, swapPhone } from '@/helpers/helpers';
import { useRouter } from 'next/router';
import { SiteContext } from '@/contexts/site-context';
import { QueryParamElement } from '@/components/QueryParamElement';
import Stars from '@/components/Stars';
import CaretIcon from 'svgs/caret.svg';

const defaultSubheadline = 'Get connected to a local pro right when you need one.';

const ArticleCopy = (props) => {
  const [site] = useContext(SiteContext);
  const [formattedDate, setFormattedDate] = useState(null);
  const subheadline = cleanHeadline(swapPhone(props.category?.subheadline || defaultSubheadline, site.phone_number));

  const router = useRouter();

  useEffect(() => {
    setFormattedDate(formatDate(props.date_published));
  }, [props.date_published, props.published_date]);

  const handleClick = () => {
    router.push(`/${props.category.use_custom_question_flow ? '/cf' : '/flow'}/${props.category.url_slug}`);
  };

  return (
    <div className={styles['article-copy-wrapper']}>
      <div className={styles['rail-wrapper']}>
        <div className={styles['rail-container']}>
          <QueryParamElement element="label" queryParam="h2" fallbackText={subheadline} />
          {props.hero_src && (
            <div className={styles['hero-image-container']}>
              <Image
                src={props.hero_src}
                alt={props.hero_alt || 'blog hero image'}
                width="100%"
                quality={80}
                placeholder="blur"
                blurDataURL="iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg=="
              />
            </div>
          )}
          <div className={styles['cta-container']}>
            <div className={styles['category-trigger']} onClick={() => handleClick()}>
              Get Help Today{' '}
              <div className={styles['icon-container']}>
                <CaretIcon />
              </div>
            </div>
          </div>
          <Stars />
        </div>
      </div>
      <div className={styles['article-copy-container']}>
        <h1 dangerouslySetInnerHTML={{ __html: props.h1 || '' }} />
        <div className={styles['attribution-container']}>
          <div className={styles['date-published']}>{formattedDate || ''}</div>
          {props.author && (
            <div className={styles['author']}>
              <span>by</span> {props.author}
            </div>
          )}
        </div>
        <div dangerouslySetInnerHTML={{ __html: props.content }} />
      </div>
    </div>
  );
};

export default ArticleCopy;
